import React, { useEffect, useState } from "react";
import classes from "./EventList.module.scss";
import Chevron from "../../UI/Icons/Chevron";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";

const EventList = ({ tableData }: { tableData: any }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [shortenedTableData, setShortenedTableData] = useState<any[]>([]);

  useEffect(() => {
    setShortenedTableData(
      tableData.slice((currentPage - 1) * 5, currentPage * 5),
    );
  }, [tableData, currentPage]);

  const pages = Math.ceil(tableData.length / 5);

  const leftBtnClickHandler = () => {
    setCurrentPage((prevState) => {
      if (prevState === 1) return 1;
      return prevState - 1;
    });
  };

  const rightBtnClickHandler = () => {
    if (pages === currentPage) return;

    setCurrentPage((prevState) => prevState + 1);
  };

  const pageBtnClickHandler = (page: number) => () => {
    setCurrentPage(page);
  };

  return (
    <>
      <div
        className={classes["event-list-container"]}
        style={shortenedTableData.length === 0 ? { border: "none" } : {}}
      >
        {shortenedTableData?.length > 0 &&
          shortenedTableData?.map((item: any, index: number) => (
            <div key={index} className={classes["event-list-item"]}>
              <h3 className={classes["event-list-item-title"]}>
                {item?.eventName}
              </h3>
              {item?.studydestination && (
                <p className={classes["event-list-item-date"]}>
                  Destination: {item?.studydestination}
                </p>
              )}
              {item?.date && (
                <p className={classes["event-list-item-date"]}>
                  Date: {item?.date}
                </p>
              )}
              {item?.time && (
                <p className={classes["event-list-item-time"]}>
                  Time: {item?.time}
                </p>
              )}
              {item?.cities && (
                <p className={classes["event-list-item-venue"]}>
                  City: {item?.cities}
                </p>
              )}
              <button
                className={`${classes["event-list-item-register-btn"]} ${!item?.register?.link && isFrappeOrJotFormClass(item?.register?.formId)}`}
                onClick={
                  item?.register?.link
                    ? () => window.open(item.register.link, "_blank")
                    : undefined
                }
              >
                {item?.register?.btnTile ?? "Register Now"}
                <Chevron color="#FF7361" width={8} height={13} />
              </button>
            </div>
          ))}
      </div>

      {shortenedTableData.length === 0 && (
        <p className={classes["event-list-no-entries"]}>No Entries to show</p>
      )}

      {/* Pagination */}
      {shortenedTableData.length !== 0 && (
        <div className={classes["pagination-container"]}>
          <button
            className={`${classes["pagination-left-button"]} ${currentPage === 1 ? classes["button-disabled"] : ""}`}
            onClick={leftBtnClickHandler}
          >
            <Chevron />
          </button>
          <div className={classes["pagination-page-buttons-container"]}>
            {Array(pages)
              .fill(0)
              .map((_, index) => (
                <button
                  key={index}
                  className={`${classes["pagination-page-button"]} ${currentPage === index + 1 ? classes["pagination-page-button-active"] : ""}`}
                  style={
                    currentPage > 3
                      ? {
                          transform: `translateX(-${(currentPage - 2) * 64}px)`,
                        }
                      : {}
                  }
                  onClick={pageBtnClickHandler(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
          </div>
          <button
            className={`${classes["pagination-right-button"]} ${currentPage === pages ? classes["button-disabled"] : ""}`}
            onClick={rightBtnClickHandler}
          >
            <Chevron />
          </button>
        </div>
      )}
    </>
  );
};

export default EventList;
